import { DeleteFileData, FileProps } from 'types/file'
import { select, put, call } from 'redux-saga/effects'
import { selectToken } from 'store/users/users.selectors'
import { setFileDeletion } from 'requests/file'
import { selectOrderRead } from 'store/order/order.selectors'
import { OrderFields } from 'types/order'
import { setInitialValuesOrderRead } from 'store/order/order.actions'
import { setFileDeletionFailure, setFileDeletionSuccess } from 'store/file/file.actions'
import { addHttpError } from 'store/http-error/http-error.actions'
import { Action } from 'redux-actions'

export function* setFileDeletionSaga(action: Action<DeleteFileData>) {
  try {
    const token = yield select(selectToken)
    yield call(setFileDeletion, action.payload, token)

    const ordersRead = yield select(selectOrderRead)

    const fileFromOrder = ordersRead?.[OrderFields.FILES]?.map((item: FileProps) => {
      return item.uuid === action.payload.uuid ? { ...item, data: { ...item.data, isDeleted: action.payload.isDeleted } } : item
    })
    yield put(
      setInitialValuesOrderRead({
        [OrderFields.FILES]: fileFromOrder,
      }),
    )
    yield put(setFileDeletionSuccess(action.payload))
  } catch (error) {
    yield put(setFileDeletionFailure(error))
    yield put(
      addHttpError({
        error,
        header: 'Удаление файла',
        defaultText: `Не удалось удалить файл.`,
        textForCase: {
          404: 'Не удалось найти файл',
        },
      }),
    )
    console.error(`[setFileDeletionSaga]: ${error}`)
  }
}
